import { type ComponentPropsWithRef, type ReactNode } from "react";
import { Button, cn } from "ui";

import { LabelPickerTriggerLabels } from "./LabelPickerTriggerLabels";

export interface LabelPickerLabel {
  id: string;
  name: string;
  description: string;
  color: string;
}

export function LabelPickerTrigger(
  props: { labels: LabelPickerLabel[] } & ComponentPropsWithRef<"button">,
) {
  const { labels, className, ...buttonProps } = props;

  return (
    <Button
      type="button"
      variant="ghost"
      {...buttonProps}
      className={cn(
        "h-7 max-w-full gap-1.5 rounded-full border bg-background px-2.5 text-xs",
        className,
      )}
    >
      <LabelPickerTriggerLabels labels={labels} />
    </Button>
  );
}

export interface LabelPickerProps {
  labels: LabelPickerLabel[];
  selectedIds: string[];
  onToggle: (labelId: string) => void;
  allowCreate?: boolean;
  trigger: ReactNode;
  align?: "start" | "center" | "end";
  placeholder?: string;
}

export { LabelPicker } from "./LabelPickerPopover";
